import type { ParsedUrlQuery } from 'querystring';

import isNil from 'lodash/isNil';

import { parse } from '@src/helpers/query';

const querySchema = { scheme: { calculator: Boolean } };
/**
 * Разрешает или запрещает показ калькулятора ПС и калькулятора на странице
 * @description
 *
 * @example
 * ```
 * const { query } = useRouter();
 * const isShowCalculator=isShowCalculatorByQuery(query);
 *
 * ```
 * @param query
 * @returns {boolean | undefined}
 */
export function isShowCalculatorByQuery(query: ParsedUrlQuery): boolean | undefined {
  try {
    const queryObject = parse({ query, ...querySchema });

    if (isNil(queryObject?.calculator)) {
      return undefined;
    }

    return queryObject.calculator === true;
  } catch (err) {
    return undefined;
  }
}
